<div class="kpi">
  @if (institution()?.iid) {
  @if(!loading())
  {
  <div class="kpi__title">{{ !invertTitles ? institution()?.label : kpiData()?.title }}</div>
  }
  @if (loading()) {
  <div class="kpi__loader loader">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
  }
  <div class="kpi__num-user" [ngClass]="{ 'kpi__num-user--up': kpiData()?.up, 'kpi__num-user--down': kpiData()?.down }">
    <div class="kpi__num-user-percent">{{ kpiData()?.currentValue }}</div>

    @if (kpiData()?.up) {
    <svg class="icon report__arrow-up" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
      <path
        d="M285.1 145.7c-3.81 8.758-12.45 14.42-21.1 14.42L184 160.1V488c0 13.25-10.75 24-24 24s-24-10.75-24-24V160.1L55.1 160.1c-9.547 0-18.19-5.658-22-14.42C30.19 136.9 31.92 126.7 38.41 119.8l104-112.1c9.5-10.23 25.69-10.23 35.19 0l104 112.1C288.1 126.7 289.8 136.9 285.1 145.7z" />
    </svg>
    }
    @if (kpiData()?.down) {
    <svg class="icon report__arrow-down red-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
      <path
        d="M34 366.3c3.811-8.758 12.45-14.42 21.1-14.42h80V24c0-13.25 10.75-24 23.1-24s24 10.75 24 24v327.9h79.1c9.547 0 18.19 5.66 22 14.42c3.811 8.754 2.076 18.95-4.408 25.94l-104 112.1c-9.5 10.23-25.69 10.23-35.19 0l-104-112.1C31.92 385.3 30.19 375.1 34 366.3z" />
    </svg>
    }
  </div>
  <div>{{ !invertTitles ? kpiData()?.title : "" }}</div>
  }
</div>